import {
    apiRequest,
    pensiunPegawaiList,
    pensiunPegawaiActive,
    pensiunPegawaiInactive
} from "../../../../../services/adapters/kepegawaian/pensiunpegawaiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pensiunPegawaiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pensiunPegawaiInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pensiunPegawaiActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository